import {
  PricingPlan,
  PricingPlanEntitlement,
} from 'src/queries/organizations/pricingPlans/pricingPlans.models'

export const TOTAL_SEATS_ENTITLEMENT_KEY = 'total-seats'

function buildQuantityMaxSeatCapDisplayName(
  plan: PricingPlan,
  formatQuantityMaxUsers: (quantityMax: number) => string = (quantityMax) =>
    `Up to ${quantityMax} users`,
): string | undefined {
  const quantityMax = plan.pricing.quantityMax

  if (quantityMax === undefined || quantityMax === null) {
    return undefined
  }

  return formatQuantityMaxUsers(quantityMax)
}

export function buildSeatCapDisplayName(
  plan: PricingPlan,
  formatQuantityMaxUsers?: (quantityMax: number) => string,
): string | undefined {
  return (
    buildQuantityMaxSeatCapDisplayName(plan, formatQuantityMaxUsers) ??
    plan.numUsersRestrictionDisplay
  )
}

export function buildEntitlementDisplayName(
  plan: PricingPlan,
  entitlement: PricingPlanEntitlement,
  formatQuantityMaxUsers?: (quantityMax: number) => string,
): string {
  if (entitlement.key !== TOTAL_SEATS_ENTITLEMENT_KEY) {
    return entitlement.displayName
  }

  return (
    buildQuantityMaxSeatCapDisplayName(plan, formatQuantityMaxUsers) ??
    entitlement.displayName
  )
}
